import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { PartnerLogos } from './components/PartnerLogos';
import { Stats } from './components/Stats';
import { Services } from './components/Services';
import { Advantages } from './components/Advantages';
import { Testimonial } from './components/Testimonial';
import { News } from './components/News';
import { Newsletter } from './components/Newsletter';
import { Footer } from './components/Footer';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { KnowledgeHub } from './pages/KnowledgeHub';
function HomePage() {
  return <main data-id="element-0">
      <Hero data-id="element-1" />
      <PartnerLogos data-id="element-2" />
      <Stats data-id="element-3" />
      <Services data-id="element-4" />
      <Advantages data-id="element-5" />
      <Testimonial data-id="element-6" />
      <News data-id="element-7" />
      <Newsletter data-id="element-8" />
    </main>;
}
export function App() {
  return <BrowserRouter data-id="element-9">
      <div className="min-h-screen bg-white font-sans selection:bg-accent/20 selection:text-primary-dark" data-id="element-10">
        <Navbar data-id="element-11" />
        <Routes data-id="element-12">
          <Route path="/" element={<HomePage data-id="element-14" />} data-id="element-13" />
          <Route path="/knowledge-hub" element={<KnowledgeHub data-id="element-16" />} data-id="element-15" />
        </Routes>
        <Footer data-id="element-17" />
      </div>
    </BrowserRouter>;
}